import React from "react";
import { useSelector } from "react-redux";
import "./styles.css";
import FloatingContainer from "../FloatingContainer";
import { selectSessionType } from "../../../store/selectors";

const help = {
  text: {
    XrScience:
      "Immersive sessions with static content. Pinch with one hand to move the object; or with both to change its size.",
    handmol:
      "Immersive molecular graphics and interactive molecular dynamics. Pinch on atoms to move them around, point at them to know their names, check your wrist for controls.",
  },
};

const HelpMenu = ({ onClose, ...props }) => {
  const sessionType = useSelector(selectSessionType);
  const helpText = sessionType === "ELEMENTS" ? help.text.XrScience : help.text.handmol;

  return (
    <FloatingContainer offset="sim" onClose={onClose} className="sim-menu" {...props}>
      <div className="column">
        <p className="menu-title">Help</p>
        <div className="help-menu column">
          <p className="side-menu-section-header">{helpText}</p>
          <p className="side-menu-section-header">
            For smoothest access, create the session on a computer and share the access codes with users who can connect
            via the web browsers of other computers, AR/VR headsets, or smartphones.
          </p>
          <p className="side-menu-section-header">
            For best immersive experience, use AR/VR headsets with hand tracking capabilities.
          </p>
          <a 
            href="https://killcloud.nyc3.cdn.digitaloceanspaces.com/scenes/mwxr_manual.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="side-menu-section-header link"
          >
            Click here to view user manual and learn more about MolecularWebXR.
          </a>
        </div>
      </div>
    </FloatingContainer>
  );
};
export default HelpMenu;
